import { map, uniq } from 'lodash'

/**
  Returns the user's two-letter browser languages in lowercase and order of preference
* */
export const getBrowserLanguage = (): string[] => {
  const locales = window.navigator.languages || [window.navigator.language || (window.navigator as any).userLanguage]

  return uniq(map(locales, (locale): string => {
    return locale.split('-')[0]
  }))
}
